export default __webpack_public_path__ + "static/char-s-34-zh-Hans-5ed691ac20f957f1bc4a34068bd50a65.png";